<template>
    <slot name="filter-field-checkbox-options" v-bind="this"></slot>
</template>

<script>
export default {
    props: {
        filterItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            checked: !this.filterItem && !this.filterItem.value
        };
    },
    watch: {
        checked(newVal) {
            this.$emit('update-option', {
                ...this.filterItem,
                value: newVal
            });
        }
    },

};
</script>
